// Environment configuration and detection
export const ENV_TYPES = {
  LOCAL: 'local',
  DEV: 'dev',
  BETA: 'beta',
  PROD: 'prod'
} as const;

export type Environment = typeof ENV_TYPES[keyof typeof ENV_TYPES];

// Get current environment from Vite environment variables
export const getCurrentEnvironment = (): Environment => {
  const env = import.meta.env.VITE_ENV as string;
  
  // Handle 'development' as alias for 'dev' for compatibility
  if (env === 'development') {
    return ENV_TYPES.DEV;
  }
  
  // Default to local if not specified
  if (!env || !Object.values(ENV_TYPES).includes(env as Environment)) {
    return ENV_TYPES.LOCAL;
  }
  
  return env as Environment;
};

// Check if current environment is dev
export const isDevEnvironment = (): boolean => {
  return getCurrentEnvironment() === ENV_TYPES.DEV;
};

// Check if current environment is beta
export const isBetaEnvironment = (): boolean => {
  return getCurrentEnvironment() === ENV_TYPES.BETA;
};

// Check if current environment is prod
export const isProdEnvironment = (): boolean => {
  return getCurrentEnvironment() === ENV_TYPES.PROD;
};

// Check if current environment is local
export const isLocalEnvironment = (): boolean => {
  return getCurrentEnvironment() === ENV_TYPES.LOCAL;
};

// Check if user has admin role
export const isAdminUser = (user: any): boolean => {
  return user && user.role === 'admin';
};

export const isAuthenticatedUser = (user: any): boolean => {
  return user && user.isAuthenticated === true;
}

// Check if user should have admin access (admin role + dev environment)
export const hasAdminAccess = (user: any): boolean => {
  return isAdminUser(user) && isDevEnvironment();
};
